import { Address, AddressComponent } from '@hero/schema';

const getDisplayName = (address: AddressComponent | undefined) => {
  return address?.name || address?.short_name || address?.long_name || address?.customCode;
};

export const getAddressDisplayNames = (address: Address) => {
  return {
    city: getDisplayName(address.city),
    country: getDisplayName(address.country),
    fullAddress: address.fullAddress,
    name: getDisplayName(address.neighborhood),
    state: getDisplayName(address.state),
    neighborhood: getDisplayName(address.neighborhood),
  };
};
